/**
 * Emojis in Vesperas Antworten — drei Stufen in EINEM Feld.
 * (29.09.2026, Ticket 2736 mit der Ergänzung aus 2737)
 *
 * Martin, 28.09.2026: *„Mit eingeschalteten Emojis kommen sie so selten und
 * zurückhaltend, dass man sie kaum bemerkt"* — Stufen aus / dezent /
 * reichlich statt An/Aus.
 *
 *   false        aus (Vorgabe; auch, wenn nichts gesetzt ist)
 *   true         dezent — so hieß der Schalter bisher „an“
 *   "reichlich"  deutlich mehr
 *
 * ⚠️ EIN Feld: `users.settings.emojisInReplies`. Die beiden alten Werte
 *    behalten ihre Bedeutung, der gespeicherte Stand braucht keinen Umzug
 *    und keinen zweiten Schlüssel für denselben Zustand — dieselbe Bauform
 *    wie `autoMikroNachFrage` (frontend/lib/settings.ts, AutoMikroStufe).
 *
 * Hier stehen nur die Werte. Die Regel je Stufe steht im Chat-Prompt
 * (server/chat.ts, EMOJI_ZEILE); der Filter der Einstellungen lässt genau
 * diese drei durch (server/settings-sanitize.ts).
 */
export type EmojiStufe = boolean | "reichlich";

/** Die drei Stufen in der Reihenfolge der Auswahl. */
export const EMOJI_STUFEN: readonly EmojiStufe[] = [false, true, "reichlich"];

/** Wie jede Stufe heißt — für Regeln und Oberfläche. */
export type EmojiStufenName = "aus" | "dezent" | "reichlich";

/** Ist das eine der drei Stufen? */
export function istEmojiStufe(x: unknown): x is EmojiStufe {
  return typeof x === "boolean" || x === "reichlich";
}

/** Die Stufe aus einem gespeicherten Wert — Unbekanntes und Fehlendes zählen als „aus“. */
export function emojiStufe(x: unknown): EmojiStufe {
  return istEmojiStufe(x) ? x : false;
}

/** Der Name der Stufe eines gespeicherten Werts. */
export function emojiStufenName(x: unknown): EmojiStufenName {
  const s = emojiStufe(x);
  return s === "reichlich" ? "reichlich" : s ? "dezent" : "aus";
}
